import React from 'react';
import { useACF } from '@context/ACFContext';
import { HeroStyled, HeroHeading } from './hero.styled';
import { useIsMobile } from '@hooks/useIsMobile';
import bgImageFallback from '@assets/images/hero-background-fallback.jpeg';
import Rating from './rating/Rating';
import Author from './author/Author';

const Hero: React.FC = () => {
	// Fetch the post template from the ACF context
	const { postTemplate } = useACF();

	const isMobile = useIsMobile();

	// ACF Fields
	const article = postTemplate?.review_page_v4_article_settings;

	const heroSettings = postTemplate?.review_page_v4_hero_settings?.metabox_settings;
	const ratingBoxSettings = postTemplate?.review_page_v4_hero_settings?.rating_box_settings;
	const heroHeading = postTemplate?.review_page_v4_hero_settings?.tr_main_heading;

	const heroImageDesktop = postTemplate?.review_page_v4_hero_settings?.hero_image_desktop;
	const heroImageMobile = postTemplate?.review_page_v4_hero_settings?.hero_image_mobile;

	const bgImage = isMobile ? heroImageMobile : heroImageDesktop;

	const ratingProps = {
		ratingIcon: ratingBoxSettings?.rating_icon,
		socialPeopleImage: ratingBoxSettings?.social_people_image,
		consumerReview: ratingBoxSettings?.tr_consumer_reviews_label,
		testedApproved: ratingBoxSettings?.tr_tested_and_approved_label,
	};

	const { article_author_image, author_name } = article?.author_component_settings || {};

	const { articles_date_days_ago } = article?.article_meta_settings || {};

	const authorProps = {
		authorName: author_name,
		dataDaysAgo: articles_date_days_ago ?? 2,
		authorImage: article_author_image,
		flagImage: heroSettings?.flag_image,
		lastUpdated: heroSettings?.tr_last_updated_label,
		writtenBy: heroSettings?.tr_written_by,
		advertisingDisclosure: heroSettings?.tr_advertising_disclosure,
		advertisingDisclosureLink: heroSettings?.advertising_disclosure_link,
	};

	return (
		<HeroStyled $bgImage={bgImage || bgImageFallback}>
			<HeroHeading>{heroHeading}</HeroHeading>
			{ratingBoxSettings?.show_rating_box && <Rating {...ratingProps} />}
			{heroSettings?.show_meta_box && <Author {...authorProps} />}
		</HeroStyled>
	);
};

export default Hero;
